import { CfaSelectCustomerColumnKey, ColumnConfig } from '../../model';

export const cfaSelectCustomerConfig: Record<
  CfaSelectCustomerColumnKey,
  ColumnConfig
> = {
  customerName: {
    name: 'Customer Name',
    // field: 'avatarNameStatus',
    field: 'customerName',
    // isComponent: true,
  },
  status: {
    name: 'Status',
    field: 'customerListStatusTag',
  },
  customerCode: { name: 'Customer Code' },
  mobileNumber: {
    name: 'Mobile Number',
    field: 'mobileNumber',
  },
  gstNumber: {
    name: 'GST Number',
    field: 'gstNumber',
  },
  placeOrder: {
    name: 'Actions',
    // field: 'textWithImage',
    field: 'placeOrder',
    // isComponent: true,
    alignment: 'center',
  },
};
